module.exports = __webpack_public_path__ + "static/Pradyumna_Rahul_K-9b721f0eb506923e98f3b432fc40a15c.jpeg";